import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMeals } from "../api/meals";
import { addMealToDay } from "../api/plans";
import { AuthContext } from "../context/AuthContext";

const MEAL_LABELS = {
  breakfast: "Breakfast",
  lunch:     "Lunch",
  dinner:    "Dinner",
  snacks:    "Snacks"
};

export default function MealPickerPage(){

  const { date, mealType } = useParams();
  const navigate = useNavigate();
  const { householdId } = useContext(AuthContext);

  const [meals, setMeals] = useState([]);
  const [search, setSearch] = useState("");
  const [activeTags, setActiveTags] = useState([]);

  useEffect(()=>{
    if(!householdId) return;
    getMeals(householdId).then(setMeals);
  },[householdId]);

  async function handleSelect(mealId){
    await addMealToDay(householdId, date, mealType, mealId);
    navigate("/planner",{ state:{ added:{ date, mealType, mealId } } });
  }

  const allTags = [...new Set(meals.flatMap(m=>m.tags||[]))].sort();

  function toggleTag(tag){
    setActiveTags(prev=>
      prev.includes(tag) ? prev.filter(t=>t!==tag) : [...prev, tag]
    );
  }

  const filtered = meals.filter(meal=>{
    const matchesSearch = !search ||
      meal.name.toLowerCase().includes(search.toLowerCase());
    const matchesTags = activeTags.length === 0 ||
      activeTags.every(t=>(meal.tags||[]).includes(t));
    return matchesSearch && matchesTags;
  });

  const label = MEAL_LABELS[mealType] || mealType;

  const [y, m, d] = date.split("-").map(Number);
  const dateLabel = new Date(y, m-1, d).toLocaleDateString("en-US",{
    weekday:"long", month:"long", day:"numeric"
  });

  return(

    <div>

      <div className="pageHeader">
        <div>
          <h2>Add {label}</h2>
          <p className="textMuted" style={{margin:0, fontSize:14}}>{dateLabel}</p>
        </div>
        <button className="discardBtn" onClick={()=>navigate("/planner")}>
          ← Back to Planner
        </button>
      </div>

      <div className="mealsControls">

        <input
          className="searchInput"
          placeholder="Search meals..."
          value={search}
          onChange={e=>setSearch(e.target.value)}
        />

        {allTags.length > 0 && (
          <div className="tagFilters">
            {allTags.map(tag=>(
              <button
                key={tag}
                className={`tagFilterChip${activeTags.includes(tag) ? " active" : ""}`}
                onClick={()=>toggleTag(tag)}
              >{tag}</button>
            ))}
          </div>
        )}

      </div>

      {filtered.length === 0 && (
        <p className="textMuted">
          No meals found.{" "}
          <a href="/meals" className="linkOlive">
            Add meals to your library first.
          </a>
        </p>
      )}

      <div className="mealGrid">
        {filtered.map(meal=>(
          <div
            key={meal.id}
            className="mealCard mealPickerCard"
            onClick={()=>handleSelect(meal.id)}
          >
            <h3>{meal.name}</h3>
            {meal.servings && (
              <p className="mealServes">Serves {meal.servings}</p>
            )}
            {(meal.tags||[]).length > 0 && (
              <div className="mealTags">
                {meal.tags.map(tag=>(
                  <span key={tag} className="mealTag">{tag}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

    </div>

  );

}
